import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import MonacoEditor from 'react-monaco-editor';
import { MonacoDiffEditor } from 'react-monaco-editor';
import './code-editor.css';

export default class CodeEditor extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			expanded: false
		};
		this.editor = null;
		this.autoBind(['updateDimensions', 'handleEditorDidMount', 'onToggleExpand']);
	}

	componentDidMount() {
		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
	}

	handleEditorDidMount(editor) {
		this.editor = editor;
		if (this.props.registerTo) {
			this.props.registerTo.editor = this.editor;
		}
	}

	updateDimensions() {
		//automaticLayout is an alternative fix but it uses an interval so has very bad performance impact
		if (this.editor && this.editor.domElement) {
			this.editor.layout({ width: this.editor.domElement.offsetWidth - 10, height: this.editor.domElement.offsetHeight });
		}
	}

	onToggleExpand() {
		this.setData('expanded', !this.data.expanded);
		setTimeout(() => {
			this.updateDimensions();
		}, 100);
	}

	render() {
		let { className, language, theme, value, onChange, original } = this.props;
		let expanded = this.data.expanded;
		return (
			<div className={`code-editor-cmp animated fadeIn ${className} ${expanded ? 'expanded-editor' : ''}`}>
				<div className="expand-btn vbox vcenter hcenter shadow hover" title={`${expanded ? 'Collapse' : 'Expand'}`} onClick={this.onToggleExpand}>
					<i className={`mdi ${expanded ? 'mdi-arrow-compress' : 'mdi-arrow-expand'}`} />
				</div>
				{original ? (
					<MonacoDiffEditor
						language={language}
						theme={theme || 'vs-dark'}
						value={value}
						original={original ? original : ''}
						options={{ readOnly: true }}
						editorDidMount={this.handleEditorDidMount}
					/>
				) : (
					<MonacoEditor
						language={language}
						theme={theme || 'vs-dark'}
						value={value}
						options={{ folding: true }}
						editorDidMount={this.handleEditorDidMount}
						onChange={onChange}
					/>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/code-editor/CodeEditor.js